import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// ⚠️ SUSTITUIR ESTAS CLAVES POR LAS QUE COPIES DE LA CONSOLA ⚠️
const firebaseConfig = {
    apiKey: "AIzaSyCOIwUpI6KWzOOA2oAxdTezbOsJlZ4ixiE",
    authDomain: "gestorpro-app.com",
    projectId: "gestorpro-app-599e3",
    storageBucket: "gestorpro-app-599e3.firebasestorage.app",
    messagingSenderId: "227584015167",
    appId: "1:227584015167:web:625837d056d4e2f46a718a",
    // measurementId retirado (FL1): Google Analytics no se usa y no está cubierto
    // por el CDPA de Google como encargado — no dejar la puerta abierta a activarlo.
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Servicios que usaremos
export const auth = getAuth(app);

// Configurar persistencia a LOCAL (persiste entre pestañas, ventanas y redirecciones)
setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error("Firebase Persistence Error:", error);
});

export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// App Check (F9): no-op si no hay site key configurada — no bloquea dev/build sin
// cuenta de reCAPTCHA. Despliegue: crear el site key reCAPTCHA v3 en la consola de
// Firebase (App Check), activarlo primero en "modo monitor" (sin enforcement) para
// verificar que el tráfico legítimo pasa, y solo entonces marcar `enforceAppCheck`
// en las Cloud Functions HTTP y activar el enforcement en Firestore Rules.
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;
if (recaptchaSiteKey) {
    try {
        initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(recaptchaSiteKey),
            isTokenAutoRefreshEnabled: true,
        });
    } catch (error) {
        console.error("[firebase] App Check init failed:", error);
    }
}

export default app;
